<button
  mat-dialog-close
  *ngIf="!dialogRef.disableClose"
  class="btn-close-dialog"
>
  <fa-icon
    [icon]="faTimes"
    size="lg"
  ></fa-icon>
</button>

<!-- Dialog -->
<div class="dialog">
  <h1 mat-dialog-title>{{ title }}</h1>

  <!-- Content -->
  <mat-dialog-content
  class="content"
  [ngClass]="{'content-left': data?.textAligned === 'left'}"
  [innerHTML]="content">
  </mat-dialog-content>
  <!-- <div
    class="content"
    mat-dialog-content
  >{{ content }}</div> -->

  <!-- Buttons -->
  <div
    mat-dialog-actions
    class="row no-gutters"
  >
    <div
      *ngIf="isCancelTextProvided"
      class="col-sm-6 order-2 order-sm-1"
      [ngClass]="{'pr-sm-1': isOkTextProvided }"
    >
      <button
        type="button"
        class="btn btn-outline-danger btn-block"
        (click)="isCancelFnExist ? data.cancelFn() : closeDialog()"
      >{{ data.cancelText }}</button>
    </div>
    <div
      *ngIf="isOkTextProvided"
      class="col-sm-6 order-1 order-sm-2"
      [ngClass]="{'pl-sm-1': isCancelTextProvided }"
    >
      <button
        type="button"
        class="btn btn-danger btn-block mb-2 mb-sm-0"
        (click)="isOkFnExist ? data.okFn() : closeDialog()"
      >{{ data.okText }}</button>
    </div>
  </div>
</div>
